<nb-card class="card" accent="success">
    <nb-card-header>
        <div>Personal & Company Info</div>
        <button mat-flat-button color="warn" (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
    </nb-card-header>

    <nb-card-body>
        <form autocomplete="off" [formGroup]="createForm">
            <div class="row">
                <div class="col-6">
                    <div class="row">
                        <div class="col-xl-11 col-xxl-11 col-lg-11 col-md-11 col-sm-11">
                            <div class="form-group">
                                <label class="label">First Name<span style="color: red">*</span></label>
                                <input type="text" nbInput fullWidth formControlName="inputFirstName"
                                    placeholder="First Name" />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xl-11 col-xxl-11 col-lg-11 col-md-11 col-sm-11">
                            <div class="form-group">
                                <label class="label">Last Name<span style="color: red">*</span></label>
                                <input type="text" nbInput fullWidth formControlName="inputLastName"
                                    placeholder="Last Name" />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xl-11 col-xxl-11 col-lg-11 col-md-11 col-sm-11">
                            <div class="form-group">
                                <label class="label">Country<span style="color: red">*</span></label>
                                <input type="text" nbInput fullWidth formControlName="inputCountry"
                                    placeholder="Country" />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xl-11 col-xxl-11 col-lg-11 col-md-11 col-sm-11">
                            <div class="form-group">
                                <label class="label">City<span style="color: red">*</span></label>
                                <input type="text" nbInput fullWidth formControlName="inputCity" placeholder="City" />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xl-11 col-xxl-11 col-lg-11 col-md-11 col-sm-11">
                            <div class="form-group">
                                <label class="label">Email<span style="color: red">*</span></label>
                                <input type="email" nbInput fullWidth formControlName="inputEmail"
                                    placeholder="Email" />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xl-11 col-xxl-11 col-lg-11 col-md-11 col-sm-11">
                            <div class="form-group">
                                <label class="label">Phone Number</label>
                                <input type="number" nbInput fullWidth formControlName="inputMobile"
                                    placeholder="Mobile Number" />
                            </div>
                        </div>
                    </div>

                    <div class="row pt-4">
                        <div class="col-xl-11 col-xxl-11 col-lg-11 col-md-11 col-sm-11">
                            <label class="label">LinkedIn</label>
                            <input type="text" nbInput fullWidth formControlName="inputLinkedIn"
                                placeholder="LinkedIn" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xl-11 col-xxl-11 col-lg-11 col-md-11 col-sm-11">
                            <label class="label">Twitter</label>
                            <input type="text" nbInput fullWidth formControlName="inputTwitter" placeholder="Twitter" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xl-11 col-xxl-11 col-lg-11 col-md-11 col-sm-11">
                            <label class="label">Website</label>
                            <input type="text" nbInput fullWidth formControlName="inputWebsite" placeholder="Website" />
                        </div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="row">
                        <div class="col-xl-11 col-xxl-11 col-lg-11 col-md-11 col-sm-11">
                            <div style="display: flex; align-items: center">
                                <label class="label">Sectors of interest</label>
                                <div>
                                    <span class="hovertext-sectors" data-hover="Select at least 2 sectors of interest">
                                        <mat-icon color="warn">error_outline</mat-icon>
                                    </span>
                                </div>
                            </div>
                            <mat-selection-list color="primary" #list [ngModelOptions]="{ standalone: true }"
                                [(ngModel)]="selectedFields" (ngModelChange)="onNgModelChange($event)">
                                <mat-list-option *ngFor="let field of typesOfFields" [value]="field"
                                    [selected]="c_field.includes(field)">
                                    {{ field }}
                                </mat-list-option>
                            </mat-selection-list>

                            <div style="margin-top: 1.5rem">
                                <label class="label">Area of studies<span style="color: red">*</span></label>
                                <mat-form-field style="width: 100%" appearance="outline">
                                    <mat-label>Select area of studies</mat-label>
                                    <mat-select formControlName="areaOfStudies" required
                                        (selectionChange)="areastudies($event)">
                                        <mat-option *ngFor="
                                                let areaOfStudy of areasOfStudy
                                            " [value]="areaOfStudy">{{ areaOfStudy }}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div class="form-group">
                                <label class="label">Field of work<span style="color: red">*</span></label>
                                <mat-form-field style="width: 100%" appearance="outline">
                                    <mat-label>Select field of work</mat-label>
                                    <mat-select formControlName="fieldOfWork" required
                                        (selectionChange)="fieldwork($event)">
                                        <mat-option *ngFor="
                                                let fieldOfWork of fieldsOfWork
                                            " [value]="fieldOfWork">{{ fieldOfWork }}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </nb-card-body>

    <nb-card-footer class="align">
        <button mat-raised-button color="primary" size="small" (click)="save()"
            [disabled]="this.createForm.invalid || selectedFields.length < 2">
            Save Changes
        </button>
    </nb-card-footer>
</nb-card>